import {SearchManager} from './search-manager';
import type {Form, SearchParams, ViewableSearch} from 'typings/portaro.be.types';
import type {UrlStateManagerService} from 'shared/state-manager/url-state-manager.service';
import type {FormDataService} from 'shared/data-services/form.data-service';
import {MemoryStateManager} from 'shared/state-manager/memory-state-manager';
import type {SearchService} from '../search.service';
import {exists} from 'shared/utils/custom-utils';

export class SearchManagerBuilderFactoryService {
    public static serviceName= 'searchManagerBuilderFactoryService';

    /*@ngInject*/
    constructor(private searchService: SearchService,
                private urlStateManagerService: UrlStateManagerService<any>,
                private formDataService: FormDataService) {
    }

    public createBuilder<PARAMS extends SearchParams, ITEM>() {
        return new SearchManagerBuilder<PARAMS, ITEM>(
            this.urlStateManagerService,
            this.searchService.search.bind(this.searchService),
            this.formDataService.getForms.bind(this.formDataService),
            {});
    }
}

export type SearchFunction<PARAMS extends SearchParams, ITEM> = (params: Partial<PARAMS>) => Promise<ViewableSearch<PARAMS, ITEM>>;
export type LoadFormsFunction<PARAMS extends SearchParams> = (params: Partial<PARAMS>) => Promise<Form[]>;

export class SearchManagerBuilder<PARAMS extends SearchParams, ITEM> {
    constructor(private urlStateManagerService: UrlStateManagerService<any>,
                private searchFunction: SearchFunction<PARAMS, ITEM>,
                private loadFormsFunction: LoadFormsFunction<PARAMS>,
                private staticParams: Partial<PARAMS>) {
    }

    public withSearchFunction(searchFunction: SearchFunction<PARAMS, ITEM>) {
        if (exists(searchFunction)) {
            this.searchFunction = searchFunction;
        }
        return this;
    }

    public withStaticParams(staticParams: Partial<PARAMS>) {
        if (exists(staticParams)) {
            this.staticParams = staticParams;
        }
        return this;
    }

    public createLocalSearch(searchOnInit = false) {
        return new SearchManager<ITEM, PARAMS>(new MemoryStateManager<PARAMS>({} as PARAMS, searchOnInit), this.staticParams, this.searchFunction, this.loadFormsFunction);
    }

    public createGlobalSearch() {
        return new SearchManager<ITEM, PARAMS>(this.urlStateManagerService, this.staticParams, this.searchFunction, this.loadFormsFunction);
    }
}